import { apiGet } from '.';
import { HelpCategory } from '@go-shared/types/help';

export async function getHelpCategories(): Promise<HelpCategory[]> {
  return apiGet(`/help`);
}
